module.exports = __webpack_public_path__ + "static/media/open-menu-table.646ced42.svg";